import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';
import ThemeProvider from 'theme/ThemeProvider';
import GlobalStyleOverrides from 'theme/GlobalStyleOverrides';
import BootConfigContext from './components/BootConfigContext/BootConfigContext';
import bootConfig from 'utils/bootConfig';
import App from './App';

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Provider store={store}>
        <GlobalStyleOverrides />
        <ThemeProvider>
          <BootConfigContext.Provider value={bootConfig}>
            <App />
          </BootConfigContext.Provider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}

if (bootConfig.isMock) {
  // Dynamic import keeps MirageJS out of the production bundle entirely.
  // The mock server is installed before the first render so API calls are intercepted.
  import('./mocks/mockServer').then(({ default: makeLibraryMockServer }) => {
    makeLibraryMockServer({ environment: 'development' });
    renderApp();
  });
} else {
  renderApp();
}
